import React from "react";
import "../../Styles/bank-balance-status.scss";

export default function BankBalanceStatus({ state, lastBalanceDate }) {
  const normalizedState = String(state || "").trim().toLowerCase();
  const hasState = ["online", "offline"].includes(normalizedState);
  const date = lastBalanceDate ? new Date(lastBalanceDate) : null;
  const hasDate = date && !Number.isNaN(date.getTime());

  if (!hasState && !hasDate) return null;

  return (
    <div className="bank-balance-status">
      {hasState ? (
        <span className={`bank-balance-status__state is-${normalizedState}`}>
          <span className="bank-balance-status__dot" aria-hidden="true" />
          {normalizedState === "online" ? "Online" : "Offline"}
        </span>
      ) : null}
      {hasDate ? (
        <div className="bank-balance-status__updated">
          <span>
            Last updated •{" "}
            <time dateTime={date.toISOString()}>
              {date.toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "2-digit",
              })}
            </time>
          </span>
          <time dateTime={date.toISOString()}>
            {date.toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
            })}
          </time>
        </div>
      ) : null}
    </div>
  );
}
